<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!--列表-->
    <el-table :data="users" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading" @selection-change="selsChange" style="width: 100%">
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="80"> </el-table-column>
      <el-table-column prop="Title" label="标题" width="" sortable>
      </el-table-column>
      <el-table-column prop="Url" label="外链" width="" sortable>
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" width="220px" sortable>
        <template slot-scope="scope">
          <img v-if="scope.row.ImgUrl" :src="scope.row.ImgUrl" class="list-image" />
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" width="" sortable>
      </el-table-column>
      <el-table-column prop="Type" label="类型" width="88px" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.Type == 1">首页</span>
        </template>
      </el-table-column>
      <el-table-column prop="Sort" label="排序" width="88px" sortable>
      </el-table-column>
      <!-- <el-table-column prop="RelationId" label="关联Id" width="" sortable>
      </el-table-column>
      <el-table-column prop="RelationType" label="关联类型" width="" sortable>
      </el-table-column> -->
      <el-table-column prop="StartDateTime" label="开始时间" width="" sortable>
      </el-table-column>
      <el-table-column prop="EndDateTime" label="结束时间" width="" sortable>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <!-- <el-col :span="24" class="toolbar">
            <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50"
                           :total="total" style="float:right;">
            </el-pagination>
        </el-col> -->

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">

      <el-form :model="editForm" label-width="80px" ref="editForm">
        <el-form-item label="广告图片">
          <el-upload class="avatar-uploader" :action="$Upload" :show-file-list="false" :headers="token" :data="ruleForm" :on-success="edithandleAvatarSuccess"
                     :before-upload="beforeAvatarUpload">
            <img v-if="editForm.ImgUrl" :src="editForm.ImgUrl" class="bcover-image" />
            <i v-else class="el-icon-plus avatar-uploader-icon plus-sign"></i>
          </el-upload>
          <span>图片尺寸：1920 * 600</span>
        </el-form-item>

        <el-form-item label="标题">
          <el-input v-model="editForm.Title" auto-complete="off" style="width: 600px;"></el-input>
        </el-form-item>
        <el-form-item label="广告链接">
          <el-input v-model="editForm.Url" auto-complete="off" style="width: 600px;"></el-input>
        </el-form-item>

        <el-form-item label="类型">
          <el-radio-group v-model="editForm.Type">
            <el-radio class="radio" :label="1">首页</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关联Id">
          <el-input v-model="editForm.RelationId" auto-complete="off" style="width: 600px;"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="editForm.Sort" :min="0" :max="200"></el-input-number>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="editForm.StartDateTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="editForm.EndDateTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="editForm.Remark" style="width: 600px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="广告图片" prop="ImgUrl">
          <el-upload class="avatar-uploader" :action="$Upload" :show-file-list="false" :headers="token" :data="ruleForm" :on-success="handleAvatarSuccess"
                     :before-upload="beforeAvatarUpload">
            <img v-if="addForm.ImgUrl" :src="addForm.ImgUrl" class="bcover-image" />
            <i v-else class="el-icon-plus avatar-uploader-icon plus-sign"></i>
          </el-upload>
          <span>图片尺寸：1920 * 600</span>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="addForm.Title" auto-complete="off" style="width: 600px;"></el-input>
        </el-form-item>
        <el-form-item label="广告链接">
          <el-input v-model="addForm.Url" auto-complete="off" style="width: 600px;"></el-input>
        </el-form-item>

        <el-form-item label="类型">
          <el-radio-group v-model="addForm.Type">
            <el-radio class="radio" :label="1">首页</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关联Id">
          <el-input v-model="addForm.RelationId" auto-complete="off" style="width: 600px;"></el-input>
        </el-form-item>

        <el-form-item label="排序">
          <el-input-number v-model="addForm.Sort" :min="0" :max="200"></el-input-number>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.StartDateTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.EndDateTime"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="addForm.Remark" style="width: 600px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date'
import { getAdvertisementPage, removeAdvertisement, editAdvertisement, addAdvertisement } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      filters: {
        name: ''
      },
      users: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [],//列表选中列

      addDialogFormVisible: false,
      editFormVisible: false,//编辑界面是否显示
      editLoading: false,
      editFormRules: {
        uLoginName: [
          { required: true, message: '请输入登录名', trigger: 'blur' }
        ],
        uRealName: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        birth: [
          { required: true, message: '请填写生日', trigger: 'blur' }
        ]
      },
      //编辑界面数据
      editForm: {
        Title: '',
        Url: '',
        ImgUrl: '',
        Remark: '',
        Type: -1,
        RelationId: 0,
        StartDateTime: '',
        EndDateTime: '',
        Sort: '',
        RelationType: ''
      }, ruleForm: {
        imgtype: "1"
      }, token: {
        Authorization: "Bearer "
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg";
        const isPNG = file.type === "image/png";
        const isGIF = file.type === "image/gif";
        const isValidType = isJPG || isPNG || isGIF;
        const isLt2M = file.size / 1024 / 1024 < 1;
        if (!isValidType) {
          this.$message.error('上传图片只能是 JPG、PNG 或 GIF 格式!');
        }
        if (!isLt2M) {
          this.$message.error("图片大小不能超过 1MB!");
        }
        return isValidType && isLt2M;
      },
      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addFormRules: {
        uLoginName: [
          { required: true, message: '请输入登录名', trigger: 'blur' }
        ],
        uRealName: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        uLoginPWD: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        birth: [
          { required: true, message: '请填写生日', trigger: 'blur' }
        ]
      },
      //新增界面数据
      addForm: {
        Title: '',
        Url: '',
        ImgUrl: '',
        Remark: '',
        Type: -1,
        RelationId: 0,
        StartDateTime: '',
        EndDateTime: '',
        Sort: '',
        RelationType: ''
      }

    }
  },
  methods: {
    handleAvatarSuccess(res, file) {
      if (res.success) {
        // 设置图片显示URL
        this.$set(this.addForm, 'ImgUrl', this.$imageApi + res.response)
        this.$message({ type: "success", message: "图片上传成功", duration: 2000 });
      } else {
        this.$set(this.addForm, 'ImgUrl', '')
        this.$message({ type: "error", message: res.msg || "图片上传失败", showClose: true });
      }
    },
    edithandleAvatarSuccess(res, file) {
      if (res.success) {
        // 设置图片显示URL
        this.$set(this.editForm, 'ImgUrl', this.$imageApi + res.response)
        this.$message({ type: "success", message: "图片上传成功", duration: 2000 });
      } else {
        this.$set(this.editForm, 'ImgUrl', '')
        this.$message({ type: "error", message: res.msg || "图片上传失败", showClose: true });
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatSex: function (row, column) {
      return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
    },
    formatBirth: function (row, column) {
      return (!row.birth || row.birth == '') ? '' : util.formatDate.format(new Date(row.birth), 'yyyy-MM-dd');
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getAdvertisement();
    },
    //获取用户列表
    getAdvertisement() {
      let para = {
        PageIndex: this.page,
        SearchInput: this.filters.name
      };
      this.listLoading = true;
      //NProgress.start();
      getAdvertisementPage(para).then((res) => {

        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        //NProgress.start();
        let para = { id: row.Id };
        removeAdvertisement(para).then((res) => {

          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          //NProgress.done();
          if (res.data.success) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });

          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }

          this.getAdvertisement();
        });
      }).catch(() => {

      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        uLoginName: '',
        uRealName: '',
        uLoginPWD: '',
        name: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: ''
      };
    },
    fileDownload() {
      let self = this
      let token = "132465"
      // 将token放到头中，设置下载进度、请求参数、返回类型
      axios({
        url: '/images/Down/Bmd?filename=' + self.rulesForm.data.ItemBmdPath,
        method: 'get',
        headers: { 'FileToken': token },
        onDownloadProgress: p => {
          // this.precent = Math.floor(100 * (p.loaded / p.total))
        },
        responseType: 'blob'
      }).then(data => {
        // 如果后端用encodeURI对文件名进行了编码，前端需用decodeURI进行解码（主要为处理特殊字符）
        let fileName = decodeURI(data.headers.filename)
        // 由于ie不支持download属性，故需要做兼容判断
        if (navigator.appVersion.toString().indexOf('.NET') > 0) {
          // ie独有的msSaveBlob属性，data.data为Blob文件流
          window.navigator.msSaveBlob(data.data, fileName)
        } else {
          // 以下流程即为文章开始的下载流程
          let url = window.URL.createObjectURL(data.data)
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href);
        }
      })
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            para.birth = (!para.birth || para.birth == '') ? util.formatDate.format(new Date(), 'yyyy-MM-dd') : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
            editAdvertisement(para).then((res) => {

              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['editForm'].resetFields();
                this.editFormVisible = false;
                this.getAdvertisement();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });

              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);
            para.birth = (!para.birth || para.birth == '') ? util.formatDate.format(new Date(), 'yyyy-MM-dd') : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
            addAdvertisement(para).then((res) => {

              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.$refs['addForm'].resetFields();
                this.addFormVisible = false;
                this.getAdvertisement();
              }
              else {
                this.$message({
                  message: res.data.msg,
                  type: 'error'
                });

              }

            });

          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },

  },
  mounted() {
    this.getAdvertisement();
    let tokenStr = window.localStorage.Token;
    this.token = {
      Authorization: "Bearer " + tokenStr
    };

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
}

</script>

<style scoped>
::v-deep .avatar-uploader .el-icon-plus,
::v-deep .avatar-uploader .el-upload,
.avatar-uploader .bcover-image,
.avatar-uploader {
  width: 576px;
  height: 180px;
  line-height: 180px;
}

.list-image{
  width: 192px;
  height: 60px;
}
</style>
